import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import { addGateway } from '../Networking/APIClient';

const buttonStyle = {
    width: 100,
    marginLeft: 20,
};

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

export const passwordHelperTextStyle = {
    marginTop: 5,
    color: '#f44336',
    padding: 0,
}

const passwordStyle = {
    width: '100%',
    marginTop: 16,
    marginBottom: 8,
}

const editTextStyle = {
    width: '100%',
}

let self;
let t;

class AssignGateway extends Component {
    constructor(props) {
        super(props);

        self = this;
        t = props.t;

        this.state = this.getInitialState(props);
    }

    getInitialState = (props) => {
        let emailValue;
        let passwordValue;

        const customerEmail = props.data.customer.email;
        emailValue = customerEmail !== null && customerEmail.includes('@') ? customerEmail : '';
        passwordValue = props.credentials.password !== 'NotASecret' ? props.credentials.password : '';

        const initialState = {
            showPassword: false,
            currentPageState: 'before',
            value_code: {
                value: '',
                error: false,
                helperText: '',
                required: true
            },
            email: {
                value: emailValue,
                error: false,
                helperText: '',
                required: true
            },
            password: {
                value: passwordValue,
                error: false,
                helperText: '',
                required: true
            },
        };
        return initialState;
    }

    onAddClicked = e => {
        e.preventDefault();
        self.props.setLoading(true);
        self.setState(self.getInitialState(self.props));

        const onOk = function onOk() {
            self.props.setLoading(false);
            self.setState({
                currentPageState: 'after',
                success: true
            });
        }

        const onError = function onError(assignGateWayError) {
            self.props.setLoading(false);
            // Handle different errors
            switch (assignGateWayError) {
                // Authentication issue, user has provided invalid credentials
                case null: {
                    self.setState({
                        email: {
                            value: self.state.email.value,
                            error: true,
                            helperText: t('user_email_or_password_wrong'),
                        },
                        password: {
                            value: self.state.password.value,
                            error: true,
                            helperText: t('user_email_or_password_wrong'),
                        }
                    });
                    return;
                }
                default: {
                    self.setState({
                        currentPageState: 'after',
                        success: false,
                    });
                    break;
                }
            }
        }

        let email = this.state.email.value.replace(/\s/g, '')
        let customerId = this.props.data.customer.customer_id
        const credentialsFromFields = {
            email: email,
            password: this.state.password.value,
        }
        addGateway(credentialsFromFields, this.state.value_code.value, customerId, onOk, onError)
    }


    onFinishClicked = e => {
        e.preventDefault();

        self.props.updateAppData();

        self.setState({
            currentPageState: 'before',
        });

        self.props.updatePage('account_overview');

    }

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowPassword = () => {
        this.setState((prevState) => {
            return {
                password: {
                    value: prevState.password.value,
                    error: prevState.password.error,
                    helperText: prevState.password.helperText,
                    showPassword: !prevState.password.showPassword
                }
            }
        });
    };

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: event.target.value
            }
        });
    };

    // This method is needed so that the soft keyboard of phones closes
    // when the "submit" button of the soft keyboard is clicked
    // on the last text field
    onKeyPressed = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            document.activeElement.blur();
        }
    }

    render() {
        let content;
        switch (this.state.currentPageState) {
            case 'before':
                content =
                    <div>
                        <div className='typography-title-container'>
                            <Typography variant="title">
                                {t('add_gateway')}
                            </Typography>
                        </div>
                        <div className="typography-title-container">
                            <Typography variant="subheading">
                                {t('add_gateway_information')}
                            </Typography>
                        </div>
                        <div>
                            <TextField style={editTextStyle}
                                required={this.state.value_code.required}
                                error={this.state.value_code.error}
                                helperText={this.state.value_code.helperText}
                                id="value_code"
                                value={this.state.value_code.value}
                                label={t('value_code')}
                                onChange={this.handleChange('value_code')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                margin="normal" />
                        </div>
                        <div>
                            <TextField style={editTextStyle}
                                required={this.state.email.required}
                                error={this.state.email.error}
                                helperText={this.state.email.helperText}
                                id="email"
                                value={this.state.email.value}
                                label={t('email')}
                                onChange={this.handleChange('email')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                margin="normal" />
                        </div>
                        <div>
                            <FormControl style={passwordStyle} required={this.state.password.required}>
                                <InputLabel htmlFor="adornment-password">{t('password')}</InputLabel>
                                <Input
                                    id="adornment-password"
                                    error={this.state.password.error}
                                    type={this.state.showPassword ? 'text' : 'password'}
                                    value={this.state.password.value}
                                    onChange={this.handleChange('password')}
                                    onKeyPress={e => this.onKeyPressed(e)}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Toggle password visibility"
                                                onClick={this.handleClickShowPassword}
                                                onMouseDown={this.handleMouseDownPassword}>
                                                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                                <FormHelperText style={passwordHelperTextStyle} id="weight-helper-text">{this.state.password.helperText}</FormHelperText>
                            </FormControl>
                        </div>
                        <div style={buttonContainerStyle}>
                            <Button
                                style={buttonStyle}
                                variant="contained"
                                color="primary"
                                onClick={e => this.onAddClicked(e)}>
                                {t('add')}
                            </Button >
                        </div>
                    </div>
                break;
            case 'after':
                content =
                    <div className="content-container">
                        <div>
                            <div className="typography-title-container">
                                <Typography variant="title" color={this.state.success ? "default" : "error"}>
                                    {this.state.success ? t('add_gateway_success_title') : t('add_gateway_failure_title')}
                                </Typography>
                            </div>
                            <div>
                                <Typography variant="subheading">
                                    {this.state.success ? t('add_gateway_success_message') : t('add_gateway_failure_message')}
                                </Typography>
                            </div>
                            <div style={buttonContainerStyle}>
                                <Button
                                    style={buttonStyle}
                                    variant="contained"
                                    color="primary"
                                    onClick={e => this.onFinishClicked(e)}>
                                    {t('finished')}
                                </Button >
                            </div>
                        </div>
                    </div>;
                break;
        }

        const contentContainer =
            <div className="content-frame">
                <Paper className="content">
                    <div className="content-container-paper">
                        {content}
                    </div>
                </Paper>
            </div>;

        return (
            <div>
                {self.props.isLoading ? null : contentContainer}
            </div>
        );
    }
}

export default AssignGateway;



// WEBPACK FOOTER //
// ./src/Pages/AssignGateway.js